<template>
    <div class="floor">
        <div class="floor-time">
            <div class="name">机房安全运行时间：</div>
            <div class="time-day">{{ days }}</div>
            <div class="space">天</div>
            <div class="time-hour">{{ hours }}</div>
            <div class="space">时</div>
            <div class="time-minute">{{ minutes }}</div>
            <div class="space">分</div>
        </div>
        <div class="floor-img">
            <img class="img1" @touchstart="isPlatenLayoutEditing ? null : handleItemClick('2F')"
                @click="isPlatenLayoutEditing ? null : handleItemClick('2F')" :class="{ 'disabled': isPlatenLayoutEditing }"
                src="@/assets/images/floor/2.png" alt="">
            <img class="img2" @touchstart="isPlatenLayoutEditing ? null : handleItemClick('1F')"
                @click="isPlatenLayoutEditing ? null : handleItemClick('1F')" :class="{ 'disabled': isPlatenLayoutEditing }"
                src="@/assets/images/floor/1.png" alt="">
            <img class="img3" @touchstart="isPlatenLayoutEditing ? null : handleItemClick('B1')"
                @click="isPlatenLayoutEditing ? null : handleItemClick('B1')" :class="{ 'disabled': isPlatenLayoutEditing }"
                src="@/assets/images/floor/B1.png" alt="">
        </div>
    </div>
</template>

<script>
import { getRoomSafety } from '@/network/extension'
import platenLayoutEdit from '@/mixins/platenLayoutEdit'

export default {
    name: "floor",
    mixins: [platenLayoutEdit],
    data() {
        return {
            startTime: '2024-01-01 00:00:00', // 设置开始运行的时间
            days: 0,
            hours: 0,
            minutes: 0,
            timer: null
        }
    },
    mounted() {
        this.startTimer();
    },
    beforeDestroy() {
        // 组件销毁前清除定时器
        if (this.timer) {
            clearInterval(this.timer);
        }
    },
    methods: {
        startTimer() {
            // 立即执行一次
            this.calculateTime();

            // 每分钟更新一次
            this.timer = setInterval(() => {
                this.calculateTime();
            }, 60000); // 60000毫秒 = 1分钟
        },
        calculateTime() {
            getRoomSafety().then(res => {
                // 确保接口返回的数据进行补零处理
                this.days = res.data.days.toString().padStart(2, '0');
                this.hours = res.data.hours.toString().padStart(2, '0');
                this.minutes = res.data.minutes.toString().padStart(2, '0');
            }).catch(err => {
                console.error('获取机房安全运行时间失败:', err);
                // 发生错误时显示默认值
                this.days = '00';
                this.hours = '00';
                this.minutes = '00';
            });
        },
        handleItemClick(spaceName) {
            if (this.isPlatenLayoutEditing) return
            this.$router.push({
                path: 'floor/floor-navigation',
                query: {
                    spaceName: spaceName
                }
            })
        },
    }
}
</script>

<style scoped>
.floor {
    width: 100%;
    height: 100%;
}

.floor-time {
    height: 12%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.floor-img {
    width: 100%;
    height: 88%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
}

.floor-tag {
    background: rgb(34 205 237);
    padding: 2px 10px;
    border-radius: 10px;
    font-weight: bold;
    font-size: 16px;
    cursor: pointer;
}

.floor-1 {
    position: absolute;
    top: 36%;
}

.floor-2 {
    position: absolute;
    top: 54%;

}

.floor-3 {
    position: absolute;
    top: 70%;

}

.floor-4 {
    position: absolute;
    top: 83%;

}

.img1 {
    cursor: pointer;
    position: absolute;
    top: 5%;
    width: 100%;
    z-index: 3;
}

.img2 {
    cursor: pointer;

    position: absolute;
    width: 100%;
    top: 30%;
    z-index: 2;
}

.img3 {
    cursor: pointer;

    position: absolute;
    top: 60%;
    width: 100%;
    z-index: 1;
}

.floor-time .name {
    color: #FFFFFF;
    font-size: 1.2rem;
}

.floor-time .time-day,
.time-hour,
.time-minute {
    padding: 5px 15px;
    color: #299BFF;
    font-size: 1.4rem;
    font-weight: bold;
    border: 1px solid #1B5D9F;
    background: #081D39;
    min-width: 60px;
    /* 添加最小宽度，避免数字变化时出现抖动 */
    text-align: center;
    /* 数字居中显示 */
}

.floor-time .space {
    margin: 0 12px;
}

/* 添加禁用状态的样式 */
.disabled {
    cursor: default !important;
}
</style>